import axios from 'axios';

// The base URL for user-related actions
const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api/users/`;

// Register user
const register = async (userData) => {
  // FIX: Append 'register' to the base URL so it hits the correct backend endpoint
  const response = await axios.post(API_URL + 'register', userData);
  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data));
  }
  return response.data;
};

// Login user
const login = async (userData) => {
  // This one was already correct
  const response = await axios.post(API_URL + 'login', userData);
  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data));
  }
  return response.data;
};

// Logout user
const logout = () => {
  localStorage.removeItem('user');
};

const authService = {
  register,
  login,
  logout,
};

export default authService;